import React, { useState } from "react";
import NavBar from "components/SideBar/SideBar2";
import { ToastContainer } from "react-toastify";
import "./style.css";
import { RingLoader } from "react-spinners";
import { useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Typography,
  InputAdornment,
} from "@material-ui/core";
import { displayValue } from "utils/randomKey";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import SearchIcon from "@material-ui/icons/Search";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import GstrFilingModal from "../../../components/Modals/GstinFilingModal/GstinFilingModal";
import { CustomTextField } from "../utility";
const Table4 = (props) => {
  const rowStyle2 = (row, rowIndex) => {
    const style = {};
    style.backgroundColor = "#fff";
    return style;
  };
  const [search, setSearch] = useState('')
  const [showGstinFillingModal, setShowGstinFillingModal] = useState(false);
  const [selectedGstin, setSelectedGstin] = useState('');
  const loaderStatus = useSelector(
    (store) => store.gstr8PrepareDataReducer.loaderStatus
  );
  async function openGstinFilingModal(gstin){
    // console.log("gstin :: ", gstin);
    setSelectedGstin(gstin);
    // await props.getGstinData(gstin);
    setShowGstinFillingModal(true);
  }
  const Table4Columns = [
    {
      dataField: "gstin",
      // text: "GSTIN",
      headerFormatter: () => (
        <>
          {/* <div
            style={{
              width: "14.28%",
              //borderRight: "1px solid  black",
              display: "inline-block",
              // padding: "12px 0px 12px",
              paddingTop: "15px",
              paddingBottom: "12px",
            }}
          >
            Revised GSTIN of Supplier
          </div>
          <div
            style={{
              width: "14.28%",
              //borderRight: "1px solid  black",
              display: "inline-block",

              paddingTop: "15px",
              paddingBottom: "12px",
            }}
          >
            Revised Gross Value of Supplies made
          </div>
          <div
            style={{
              width: "14.28%",
              //borderRight: "1px solid  black",
              display: "inline-block",

              paddingTop: "15px",
              paddingBottom: "12px",
            }}
          >
            Revised Values of Supplies Returned
          </div>
          <div
            style={{
              width: "14.28%",
              //borderRight: "1px solid  black",
              display: "inline-block",

              paddingTop: "15px",
              paddingBottom: "12px",
            }}
          >
           Revised  Net Amount liable for TCS
          </div>
          <div
            style={{
              width: "14.28%",
              //borderRight: "1px solid  black",
              display: "inline-block",

              paddingTop: "15px",
              paddingBottom: "12px",
            }}
          >
           Revised  IGST
          </div>
          <div
            style={{
              width: "14.28%",
              //borderRight: "1px solid  black",
              display: "inline-block",

              paddingTop: "15px",
              paddingBottom: "12px",
            }}
          >
            Revised CGST
          </div>
          <div
            style={{
              width: "14.28%",
              //borderRight: "1px solid  black",
              display: "inline-block",
              paddingLeft:"3.5%",
              paddingTop: "15px",
              paddingBottom: "12px",
              textAlign: "left"
            }}
          >
            Revised SGST
          </div> */}
          <div style={{width:"100%", display:"flex"}}>
          <div
            style={{
              width: "15%",
              //borderRight: "1px solid  black",
              display: "inline-block",
              textWrap:"wrap",
              // padding: "12px 0px 12px",
              paddingTop: "15px",
              paddingBottom: "12px",
            }}
          >
            Revised GSTIN of Supplier
          </div>
          <div
            style={{
              width: "14%",
              //borderRight: "1px solid  black",
              display: "inline-block",
              textWrap:"wrap",
              paddingTop: "15px",
              paddingBottom: "12px",
            }}
          >
            Revised Gross Value of Supplies made
          </div>
          <div
            style={{
              width: "14%",
              //borderRight: "1px solid  black",
              display: "inline-block",
              textWrap:"wrap",
              paddingTop: "15px",
              paddingBottom: "12px",
            }}
          >
            Revised Values of Supplies Returned
          </div>
          <div
            style={{
              width: "14%",
              //borderRight: "1px solid  black",
              display: "inline-block",
              textWrap:"wrap",
              paddingTop: "15px",
              paddingBottom: "12px",
            }}
          >
           Revised Net Amount liable for TCS
          </div>
          <div
            style={{
              width: "14%",
              //borderRight: "1px solid  black",
              display: "inline-block",
              textWrap:"wrap",
              paddingTop: "15px",
              paddingBottom: "12px",
            }}
          >
            IGST
          </div>
          <div
            style={{
              width: "14%",
              //borderRight: "1px solid  black",
              display: "inline-block",
              textWrap:"wrap",
              paddingTop: "15px",
              paddingBottom: "12px",
            }}
          >
            CGST
          </div>
          <div
            style={{
              width: "14%",
              //borderRight: "1px solid  black",
              display: "inline-block",
              paddingLeft: "4%",
              paddingTop: "15px",
              paddingBottom: "12px",
              textAlign: "left",
              textWrap:"wrap",
            }}
          >
            SGST
          </div>
          </div>
        </>
      ),
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const padding = "0";
        const border = "none";
        return { fontFamily, fontSize, fontWeight, padding, border };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        padding: "0",
      },
      formatter: (cell, row) => {
        return (
          <>
            <div style={{ width: "100%" }}>
              <Accordion style={{ width: "100%" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  style={{
                    display: "block",
                    minHeight: "0px",
                    height: "28px",
                    position: "relative",
                  }}
                  className="gstr8-savedtab-accordion"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <Typography
                    style={{
                      width: "15.6%",
                      textAlign: "center",
                      //borderRight: "1px solid black",
                      fontSize: "12px",
                      paddingTop: "6px",
                      fontWeight: "800",
                    }}
                  >
                    {row.stin}&nbsp;&nbsp;&nbsp;
                    <svg
                      onClick={() => openGstinFilingModal(row.stin)}
                      //onClick={handleGstinOpen}
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      color="rgba(0, 167, 181, 1)"
                      fill="currentColor"
                      class="bi bi-box-arrow-up-right"
                      viewBox="0 0 16 16"
                     
                    >
                      <path
                        fill-rule="evenodd"
                        d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                      />
                    </svg>
                  </Typography>
                  <Typography
                    style={{
                      width: "14.7%",
                      textAlign: "center",
                      //borderRight: "1px solid  black",
                      fontSize: "12px",
                      paddingTop: "6px",
                      fontWeight: "800",
                    }}
                  >
                     {(row.grossValSup != null && row.grossValSup != undefined)?displayValue(row.grossValSup):"--"}
                    {/* { !isNaN(row.grossValSup) ? row.grossValSup : "--"} */}
                  </Typography>
                  <Typography
                    style={{
                      width: "14.5%",
                      textAlign: "center",
                      //borderRight: "1px solid  black",
                      fontSize: "12px",
                      paddingTop: "6px",
                      fontWeight: "800",
                    }}
                  >
                     {(row.valSup != null && row.valSup != undefined)?displayValue(row.valSup):"--"}
                    {/* { !isNaN(row.valSup) ? row.valSup : "--"} */}
                  </Typography>
                  <Typography
                    style={{
                      width: "14.5%",
                      textAlign: "center",
                      //borderRight: "1px solid  black",
                      fontSize: "12px",
                      paddingTop: "6px",
                      fontWeight: "800",
                    }}
                  >
                     {(row.netAmtSup != null && row.netAmtSup != undefined)?displayValue(row.netAmtSup):"--"}
                    {/* { !isNaN(row.netAmtSup) ? row.netAmtSup : "--"} */}
                  </Typography>
                  <Typography
                    style={{
                      width: "14.7%",
                      textAlign: "center",
                      //borderRight: "1px solid  black",
                      fontSize: "12px",
                      paddingTop: "6px",
                      fontWeight: "800",
                    }}
                  >
                     {(row.igst != null && row.igst != undefined)?displayValue(row.igst):"--"}
                    {/* { !isNaN(row.igst) ? row.igst : "--"} */}
                  </Typography>
                  <Typography
                    style={{
                      width: "14.5%",
                      textAlign: "center",
                      //borderRight: "1px solid  black",
                      fontSize: "12px",
                      paddingTop: "6px",
                      fontWeight: "800",
                    }}
                  >
                     {(row.cgst != null && row.cgst != undefined)?displayValue(row.cgst):"--"}
                    {/* { !isNaN(row.cgst) ? row.cgst : "--"} */}
                  </Typography>
                  <Typography
                    style={{
                      width: "11.6%",
                      textAlign: "center",
                      //borderRight: "1px solid  black",
                      fontSize: "12px",
                      paddingTop: "6px",
                      fontWeight: "800",
                    }}
                  >
                     {(row.sgst != null && row.sgst != undefined)?displayValue(row.sgst):"--"}
                    {/* { !isNaN(row.sgst) ? row.sgst : "--"} */}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <BootstrapTable
                    keyField="gstin"
                    data={row.data_json}
                    // data={[
                    //   {
                    //     T: "TDS",
                    //     A: "Accept",
                    //     C: "25",
                    //     TV: "18,000",
                    //     IGST: "18,000",
                    //     CGST: "18,000",
                    //     SGST: "18,000",
                    //   },
                    // ]}
                    columns={Table4SubColumns}
                    rowStyle={rowStyle2}
                  />
                </AccordionDetails>
              </Accordion>
            </div>
          </>
        );
      },
    },
  ];
  const Table4SubColumns = [
    {
      dataField: "recipient",
      text: "",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const width = '15%';
        return { fontFamily, fontSize, fontWeight, textAlign,width };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "5%",
        display: "none",
      },
    },
    {
      dataField: "grossValSup",
      text: "",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const width = '14%';
        return { fontFamily, fontSize, fontWeight, textAlign ,width};
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "5%",
        display: "none",
      },
      formatter:(col, row)=>{
        return (
          <>
          {(row.grossValSup != null && row.grossValSup != undefined)?displayValue(row.grossValSup):"--"}
          </>
        )
      }
    },
    {
      dataField: "valSup",
      text: "",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const width = '14%';
        return { fontFamily, fontSize, fontWeight, textAlign,width };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "5%",
        display: "none",
      },
      formatter:(col, row)=>{
        return (
          <>
          {(row.valSup != null && row.valSup != undefined)?displayValue(row.valSup):"--"}
          </>
        )
      }
    },
    {
      dataField: "netAmtSup",
      text: "",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const width = '14%';
        return { fontFamily, fontSize, fontWeight, textAlign ,width};
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "12%",
        display: "none",
      },
      formatter:(col, row)=>{
        return (
          <>
          {(row.netAmtSup != null && row.netAmtSup != undefined)?displayValue(row.netAmtSup):"--"}
          </>
        )
      }
    },
    {
      dataField: "igst",
      text: "",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const width = '14%';
        return { fontFamily, fontSize, fontWeight, textAlign,width };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "12%",
        display: "none",
      },
      formatter:(col, row)=>{
        return (
          <>
          {(row.igst != null && row.igst != undefined)?displayValue(row.igst):"--"}
          </>
        )
      }
    },
    {
      dataField: "cgst",
      text: "",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const width = '14%';
        return { fontFamily, fontSize, fontWeight, textAlign ,width};
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "12%",
        display: "none",
      },
      formatter:(col, row)=>{
        return (
          <>
          {(row.cgst != null && row.cgst != undefined)?displayValue(row.cgst):"--"}
          </>
        )
      }
    },
    {
      dataField: "sgst",
      text: "",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        const width = '15.5%';
        const paddingRight = "4%";
        return { fontFamily, fontSize, fontWeight, textAlign ,width, paddingRight};
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "12%",
        display: "none",
      },
      formatter:(col, row)=>{
        return (
          <>
          {(row.sgst != null && row.sgst != undefined)?displayValue(row.sgst):"--"}
          </>
        )
      }
    },
  ];
  return (
    <div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex" }} >
          <Button
          onClick={()=>{props.setShowViewTab(false)}}
            variant="outlined"
            color="primary"
            startIcon={<ArrowBackIosIcon />}
            style={{
              //   backgroundColor: "#4f2d7f",
              color: "#4f2d7f",
              height: "30px",
              textTransform: "capitalize",
              marginTop:'4px'
            }}
          >
            Back
          </Button>{" "}
          <div className="span-text">4. Amendments to details of supplies attracting TCS</div></div>
          <div style={{ display: "flex" }}>
          <div  className="search-custom">
            <CustomTextField
           
           onChange={(e)=>setSearch(e.target.value)}
           value={search}
              placeholder="Search"
              variant="outlined"
              size="small"
              // onChange={handleInputChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            
          </div>
          <Button
              variant="contained"
              color="primary"
              onClick={()=>props.getViewTableData(props.supType,search)}
              style={{
                backgroundColor: "#4f2d7f",
                color: "white",
                height: "30px",
marginTop:"4px",
padding: '0em 2em',
                textTransform: "capitalize",
              }}
            >
              Search
            </Button>
            </div>
        </div>
        {props.viewTabData?.length > 0 ? <>
        <div style={{marginTop:"1em"}}>
          <div>
          <div
                style={{
                  display: "flex",
                  borderLeft:"2px solid #d9dbdf",
                  borderRight:"2px solid #d9dbdf",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#4F2D7F",
                    width: "55%",
                  }}
                ></div>

                <div
                  style={{
                    backgroundColor: "#4F2D7F",
                    padding: "10px",
                    color: "white",
                    fontSize: 12,
                    fontWeight: "800",
                    //lineHeight: 1,
                    wordWrap: "break-word",
                    width: "45%",
                    textAlign: "center",
                    //   //borderRight: "2px solid #f3f4ff",
                  }}
                >
                  Revised Amount of Tax collected at source
                </div>
                {/* <div style={{ backgroundColor: "#4F2D7F", width: "12%" }}></div> */}
          </div>
       
        {(() => {
          const headers = [
            "GSTIN of ECO",
            "Original Return Period",
            "Revised GSTIN of Supplier",
            "Revised POS",
            "Original GSTIN of Supplier",
            "Original POS",
            "Name of Supplier",
            "Status of Recipient",
            "Gross Value of Supplies Made",
            "Value of Supplies Returned",
            "Net Amount Liable to TCS",
            "IGST",
            "CGST",
            "SGST",
          ];

          const formatAmount = (v) => {
            if (v === null || v === undefined || v === "" || isNaN(Number(v))) return "--";
            return Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          };

          // Flatten data and group by Revised GSTIN of Supplier for row merging
          const flattenedData = [];
          if (props.viewTabData && props.viewTabData.length > 0) {
            props.viewTabData.forEach((row, idx) => {
              if (row.data_json && row.data_json.length > 0) {
                row.data_json.forEach((sinData, dataIdx) => {
                  flattenedData.push({
                    ...sinData,
                    rowIdx: idx,
                    dataIdx: dataIdx,
                    parentRow: row,
                    supplierGstin: sinData.stin || "--",
                  });
                });
              }
            });
          }

          // Group by supplier GSTIN to calculate rowSpan
          const supplierGroups = {};
          flattenedData.forEach((item, index) => {
            const key = item.supplierGstin;
            if (!supplierGroups[key]) {
              supplierGroups[key] = { firstIndex: index, count: 0, firstItem: item };
            }
            supplierGroups[key].count++;
          });

          const rows = flattenedData.map((sinData, index) => {
            const supplierGstin = sinData.supplierGstin;
            const group = supplierGroups[supplierGstin];
            const isFirstInGroup = group.firstIndex === index;
            const row = sinData.parentRow;

            return (
              <tr key={`${sinData.rowIdx}-${sinData.dataIdx}`} className={sinData.rowIdx % 2 === 0 ? "even" : "odd"}>
                <td className="text-left">{sinData.gstin || "--"}</td>
                <td className="text-left">{row.ofp || row.originalReturnPeriod || props.selectedPeriod || props.selectedPeriodSingle || "--"}</td>
                <td className="text-left">{supplierGstin}</td>
                <td className="text-left">{sinData.pos || sinData.place_of_supply || "--"}</td>
                <td className="text-left">{sinData.ostin || "--"}</td>
                <td className="text-left">{sinData.opos || "--"}</td>
                <td className="text-left">{sinData.LN || sinData.supName || sinData.name || sinData.supplierName || "--"}</td>
                <td className="text-left">{sinData.recipient || sinData.recipientStatus || sinData.status || "--"}</td>
                <td className="numeric">{formatAmount(sinData.grossValSup)}</td>
                <td className="numeric">{formatAmount(sinData.valSup)}</td>
                <td className="numeric">{formatAmount(sinData.netAmtSup)}</td>
                {isFirstInGroup && (
                  <>
                    <td className="numeric" rowSpan={group.count}>{formatAmount(group.firstItem.igst)}</td>
                    <td className="numeric" rowSpan={group.count}>{formatAmount(group.firstItem.cgst)}</td>
                    <td className="numeric" rowSpan={group.count}>{formatAmount(group.firstItem.sgst)}</td>
                  </>
                )}
              </tr>
            );
          });

          return (
            <div className="tableWrapper">
              <table className="gst-table">
                <thead>
                  <tr>
                    {headers.map((h) => (
                      <th key={h}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {rows && rows.length > 0 ? (
                    rows
                  ) : (
                    <tr>
                      <td colSpan={headers.length} className="no-data">
                        No Data Available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          );
        })()}
            
          </div>
        </div></> : <div
            style={{
              height: "40vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography style={{ fontWeight: "800" }}>
              No Data Available
            </Typography>
          </div>}
        <Dialog
    aria-labelledby="customized-dialog-title"
    fullWidth={true}
    maxWidth="sm"
    open={showGstinFillingModal}
  >
    <MuiDialogTitle
      disableTypography
      style={{ backgroundColor: "#4f2d7f", color: "white" }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h6">{"GSTIN/Filing Status"}</Typography>
        <CloseIcon
          onClick={()=>setShowGstinFillingModal(false)}
          color="white"
          style={{ cursor: "pointer" }}
        />
      </div>
    </MuiDialogTitle>
    <MuiDialogContent dividers>
      <div>
        <GstrFilingModal
        dedgstin={selectedGstin}
        fyear={props.selectedPeriod}
        />
      </div>
    </MuiDialogContent>
</Dialog>
    </div>
  );
};

export default Table4;
